module.exports = __webpack_public_path__ + "media/images/black_history_month/vector1-64ee7f9e43f31325c947c0f0514dd1db.svg";